var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1654 44.6667L33.9987 33.5L22.832 44.6667",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33.5V58.625",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4226 51.3388C60.1455 49.8544 62.2964 47.5055 63.536 44.6628C64.7757 41.8202 65.0333 38.6457 64.2684 35.6404C63.5035 32.635 61.7595 29.97 59.3117 28.0659C56.8639 26.1618 53.8517 25.1271 50.7506 25.125H47.2331C46.3881 21.8566 44.8131 18.8224 42.6267 16.2503C40.4402 13.6782 37.6991 11.6353 34.6094 10.275C31.5198 8.91482 28.1619 8.27272 24.7884 8.39701C21.4148 8.52131 18.1134 9.40876 15.1322 10.9927C12.151 12.5766 9.56765 14.8157 7.57638 17.5417C5.58511 20.2677 4.23774 23.4096 3.63555 26.7313C3.03336 30.053 3.19202 33.468 4.09961 36.7195C5.00721 39.9711 6.64011 42.9745 8.87556 45.5042",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1654 44.6667L33.9987 33.5L22.832 44.6667",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8682f5d353b430689e6dac84a845bdc6.svg";
export { ForwardRef as ReactComponent };